(function () {
  var gate = document.getElementById('rv-age-gate');
  if (!gate) return;

  var yesBtn = document.getElementById('rv-age-yes');
  var noBtn = document.getElementById('rv-age-no');

  if (yesBtn) {
    yesBtn.addEventListener('click', function () {
      localStorage.setItem('rv_age_accepted_at', new Date().getTime().toString());
      gate.style.display = 'none';
      gate.classList.add('is-hidden');
    });
  }

  if (noBtn) {
    noBtn.addEventListener('click', function () {
      window.location.href = 'https://www.google.com';
    });
  }
})();
